import React from 'react';

// Checkbox with Xmind-style partial progress: an empty ring, a pie filling
// clockwise from 12 o'clock, then a solid tick at 100%.
interface ProgressCheckProps {
  value: number;
  onToggle?: () => void;
  disabled?: boolean;
  label: string;
  size?: number;
}

function piePath(progress: number): string {
  const r = 5.5;
  const angle = (Math.min(99.9, progress) / 100) * Math.PI * 2;
  const x = 10 + r * Math.sin(angle);
  const y = 10 - r * Math.cos(angle);
  const large = progress > 50 ? 1 : 0;
  return `M10 10 L10 ${10 - r} A${r} ${r} 0 ${large} 1 ${x.toFixed(2)} ${y.toFixed(2)} Z`;
}

const ProgressCheck: React.FC<ProgressCheckProps> = ({ value, onToggle, disabled, label, size = 20 }) => {
  const done = value >= 100;
  const partial = value > 0 && !done;
  return (
    <button
      type="button"
      className={`tk-check${done ? ' is-done' : ''}${partial ? ' is-partial' : ''}`}
      onClick={onToggle}
      disabled={disabled}
      aria-pressed={done}
      aria-label={`${label}${partial ? ` (${value}% done)` : ''}`}
      title={partial ? `${value}% done` : undefined}
    >
      <svg width={size} height={size} viewBox="0 0 20 20" aria-hidden="true">
        <circle className="tk-check-ring" cx="10" cy="10" r="8.25" />
        {partial && <path className="tk-check-pie" d={piePath(value)} />}
        {done && <path className="tk-check-tick" d="M6 10.4l2.7 2.7L14.2 7.4" />}
      </svg>
    </button>
  );
};

export default ProgressCheck;
